export default {
  primary: '#FC0E94',
  secundary: '#D360FC',
  lightPink: '#FFAAFF',
};
